var render = function () {
  var _vm$percentageAmount;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Revenue Shares',
        to: '/revenueshares'
      }, {
        label: 'Edit'
      }],
      "title": "Edit Revenue Shares"
    }
  }), _c('div', {
    staticClass: "bg-white py-2.5 rounded-lg shadow-sm mb-4"
  }, [_c('div', {
    staticClass: "flex-col justify-between py-0 mx-4 pb-4 w-1/2"
  }, [_c('div', [_c('label', {
    staticClass: "block mt-0 mb-2 font-medium text-gray-700"
  }, [_vm._v("Revenue Share Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.name,
      expression: "name"
    }],
    class: ['w-full rounded-md px-4 py-2.5 mb-2 text-sm focus:outline-none focus:ring-2', _vm.submitted && !_vm.name ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter Revenue Share Name"
    },
    domProps: {
      "value": _vm.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value;
      }
    }
  }), _vm.submitted && !_vm.name ? _c('p', {
    staticClass: "text-red-500 text-sm mt-0"
  }, [_vm._v("Must be filled.")]) : _vm._e()]), _c('div', [_c('label', {
    staticClass: "block mt-0 mb-2 font-medium text-gray-700"
  }, [_vm._v("Description")]), _c('t-textarea', {
    staticClass: "rounded-lg mb-4",
    attrs: {
      "id": "description",
      "type": "number",
      "placeholder": "Enter description about revenue share..."
    },
    model: {
      value: _vm.description,
      callback: function ($$v) {
        _vm.description = $$v;
      },
      expression: "description"
    }
  })], 1), _c('div', [_c('label', {
    staticClass: "block mt-0 mb-2 font-medium text-gray-700"
  }, [_vm._v("Default Fixed Amount")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.fixedAmount,
      expression: "fixedAmount"
    }],
    class: ['w-full rounded-md px-4 py-2.5 mb-2 text-sm focus:outline-none focus:ring-2', _vm.submitted && !_vm.fixedAmount ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '],
    attrs: {
      "id": "fixedAmount",
      "type": "number",
      "placeholder": "Enter Value of Default Fixed Amount"
    },
    domProps: {
      "value": _vm.fixedAmount
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.fixedAmount = $event.target.value;
      }, _vm.setFixed]
    }
  }), _vm.submitted && !_vm.fixedAmount ? _c('p', {
    staticClass: "text-red-500 text-sm my-0"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("Converted data : " + _vm._s(_vm.convertedFixed))])]), _c('div', {
    staticClass: "relative"
  }, [_c('label', {
    staticClass: "block mt-0 mb-2 font-medium text-gray-700"
  }, [_vm._v("Default Percentage Amount")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.percentageAmount,
      expression: "percentageAmount"
    }],
    class: ['w-full rounded-md px-4 py-2.5 mb-2 text-sm focus:outline-none focus:ring-2', _vm.submitted && !_vm.percentageAmount ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '],
    attrs: {
      "id": "percentageAmount",
      "type": "number",
      "placeholder": "Enter Value of Percentage Fixed Amount"
    },
    domProps: {
      "value": _vm.percentageAmount
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.percentageAmount = $event.target.value;
      }, _vm.setPercentage]
    }
  }), _vm.submitted && !_vm.percentageAmount ? _c('p', {
    staticClass: "text-red-500 text-sm my-0"
  }, [_vm._v("Must be filled.")]) : _vm._e(), _c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("Converted data : " + _vm._s(_vm.convertedPercentage))]), ((_vm$percentageAmount = _vm.percentageAmount) === null || _vm$percentageAmount === void 0 ? void 0 : _vm$percentageAmount.length) > 0 ? _c('span', {
    staticClass: "absolute inset-y-0 right-3 flex items-center text-gray-500 text-sm"
  }, [_vm._v(" % ")]) : _vm._e()]), _c('div', {
    staticClass: "mb-3 mr-0"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Status ")]), _c('div', [_c('button', {
    staticClass: "w-12 h-6 button-active-inactive rounded-full relative transition-colors duration-200 focus:outline-none",
    class: {
      'bg-blue-700': this.isActive,
      'bg-gray-300': !this.isActive
    },
    attrs: {
      "clas": "",
      "type": "button"
    },
    on: {
      "click": _vm.toggleActive
    }
  }, [_c('span', {
    staticClass: "w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200",
    class: {
      'translate-x-6': this.isActive,
      'translate-x-0': !this.isActive
    }
  })])])]), _c('div', {
    staticClass: "flex justify-start"
  }, [_c('button', {
    staticClass: "mr-3 text-white bg-blue-700 rounded-lg px-2.5 py-2",
    attrs: {
      "type": "click"
    },
    on: {
      "click": _vm.updateRevenueShare
    }
  }, [_vm._v(" Save ")]), _c('button', {
    staticClass: "bg-white border text-gray-700 rounded-lg px-2.5 py-2",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/revenueshares');
      }
    }
  }, [_vm._v("Cancel")])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }